import React from 'react';
import { Box, Typography, LinearProgress } from '@mui/material';

const ProfilerStats = ({ stats }) => {
    if (!stats || typeof stats !== 'object') return null;

    // Determine max time to normalize bars
    const maxTotal = Math.max(...Object.values(stats).map(s => s.total_time));

    return (
        <Box sx={{ mt: 2 }}>
            {Object.entries(stats).map(([key, value]) => {
                const percent = (value.total_time / maxTotal) * 100;

                return (
                    <Box key={key} sx={{ mb: 2 }}>
                        <Typography variant="subtitle2">{key}</Typography>
                        <LinearProgress
                            variant="determinate"
                            value={percent}
                            sx={{
                                height: 8,
                                borderRadius: 1,
                                backgroundColor: '#666',
                                '& .MuiLinearProgress-bar': {
                                backgroundColor: percent > 75 ? '#ff4444' : '#66bb6a',
                                },
                            }}
                        />
                        <Typography variant="caption" color="text.secondary">
                            count: {value.count}, total: {value.total_time.toFixed(2)}s, mean: {value.mean_time.toFixed(3)}s, std: {value.std_dev.toFixed(3)}s
                        </Typography>
                    </Box>
                );
            })}
        </Box>
    );
};

export default ProfilerStats;
